import ReportsWorkspace from "@/components/feature/reports/ReportsWorkspace";
import { useAgenceReports } from "./useAgenceReports";

export default function AgenceRapportsPage() {
  const { reportTypes, options, getStatutConfig, buildReport } = useAgenceReports();

  return (
    <ReportsWorkspace
      heading="Rapports"
      intro="Générez, prévisualisez puis téléchargez les rapports de l'agence. Chaque rapport s'appuie sur les données réellement accessibles à votre compte et respecte exactement les filtres sélectionnés."
      reportTypes={reportTypes}
      options={options}
      getStatutConfig={getStatutConfig}
      buildReport={buildReport}
      filenamePrefix="rapports-agence"
    />
  );
}